module.exports = __webpack_public_path__ + "static/media/home.602cbc73.svg";